import React from 'react'
import { commerce } from '../../lib/commerce';
import {Form, Button} from 'react-bootstrap';
import {Elements, CardElement, ElementsConsumer} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Review from './Review';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentForm = ({checkoutToken, shippingData, backStep, nextStep, handleCaptureCheckout}) => {
  const handleSubmit = async (event, elements, stripe) =>{
    event.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const {error, paymentMethod} = await stripe.createPaymentMethod({type:'card', card:cardElement});

    console.log(shippingData.shippingOption)

    if(error){
      console.log(error)
      console.log(error.data.error.message);
    }else{
      const orderData = {
        line_items: checkoutToken.line_items,
        customer: {firstname: shippingData.firstName, 
          lastname: shippingData.lastName, 
          email: shippingData.email},
        shipping: {name: 'Primary', 
          street:shippingData.address1, 
          town_city: shippingData.city,
          county_state: shippingData.shippingState, 
          postal_zip_code: shippingData.zip,
          country: shippingData.shippingCountry
        },
        fulfillment: {shipping_method: shippingData.shippingOption},
        payment: {
          gateway: 'stripe',
          stripe: {
            payment_method_id: paymentMethod.id
          }
        }
      }

      handleCaptureCheckout(checkoutToken, orderData);
      nextStep();
    }
  }

  return (
    <>
    <Review checkoutToken={checkoutToken}/>
    <h6>Payment method</h6>
    <Elements stripe={stripePromise}>
      <ElementsConsumer>
        {({elements, stripe})=>(
          <Form onSubmit={(e)=>handleSubmit(e, elements, stripe)}>
            <CardElement/>
            <br/>
            <div>
            <Button variant='outline' onClick={backStep}>Back</Button>
            <Button type='submit' variant="contained" disabled={!stripe} color="primary">
              Pay { checkoutToken.subtotal.formatted_with_symbol }
            </Button>
            </div>
          </Form>
        )}
      </ElementsConsumer>
    </Elements>
    </>
  )
}

export default PaymentForm;
